import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { SectionTitle } from "@/components/Shared";

export default function Reviews({ category, dark = false }) {
  const { reviews } = useSite();
  const list = category ? reviews.filter((r) => r.category === category) : reviews;
  if (list.length === 0) return null;
  const accent = category === "spa" ? "#C59B6D" : "#D4AF37";
  return (
    <section data-testid="reviews-section" className={`${dark ? "bg-[#0B0A0C]" : ""} py-20`}>
      <div className="max-w-7xl mx-auto px-6">
        <SectionTitle overline="Dicono di Noi" title="Le Voci dei Nostri Ospiti" />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.slice(0, 6).map((r, i) => (
            <motion.blockquote key={r.id} data-testid={`review-card-${r.id}`}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }}
              className="relative p-7 rounded-2xl border bg-[#141217]" style={{ borderColor: `${accent}26` }}>
              <Quote className="w-8 h-8 absolute top-5 right-5 opacity-20" style={{ color: accent }} />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-3.5 h-3.5" style={{ color: accent, fill: k < r.rating ? accent : "transparent" }} />
                ))}
              </div>
              <p className="text-sm text-[#D8D2CE] leading-relaxed italic mb-5">“{r.text}”</p>
              <div className="flex items-center gap-2">
                <span className="font-display text-base text-[#FBF8F5]">{r.author}</span>
                <span className="text-[0.6rem] px-2 py-0.5 rounded-full uppercase tracking-wider" style={{ background: `${accent}22`, color: accent }}>
                  {r.category === "spa" ? "Spa" : "Club"}
                </span>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
